module.exports = __webpack_public_path__ + "static/media/member_15.5ba79125.png";